import { useCallback, useRef, useState } from "react";
import { api } from "../lib/api";

// Recovers the passenger's trip-completion summary from the server, even if
// the live `ride_completed` message was missed. Each ride is shown at most once per session.
export function useCompletionRecovery() {
  const [completedRide, setCompletedRide] = useState(null);
  const shownRef = useRef(new Set());
  const openIdRef = useRef(null);

  const checkCompletion = useCallback(async () => {
    try {
      const { data } = await api.get("/passenger/last-completed");
      if (!data) return;
      if (shownRef.current.has(data.id) && openIdRef.current !== data.id) return;
      shownRef.current.add(data.id);
      openIdRef.current = data.id;
      setCompletedRide(data);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[passenger] /passenger/last-completed failed:", e?.message);
    }
  }, []);

  const dismissCompletion = useCallback(async () => {
    const id = openIdRef.current;
    openIdRef.current = null;
    setCompletedRide(null);
    if (!id) return;
    try {
      await api.post(`/passenger/rides/${id}/completion-seen`);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[passenger] completion-seen failed:", e?.message);
    }
  }, []);

  return { completedRide, checkCompletion, dismissCompletion };
}
